import { StepperProps } from './type/Stepper.type';

export function StepperTitle({ title }: Pick<StepperProps, 'title'>) {
  return <div className="body-small-medium break-all flex-1 text-primary-foreground-main">{title}</div>;
}
